import { render, staticRenderFns } from "./eventolaborantes.vue?vue&type=template&id=287100e6"
import script from "./eventolaborantes.vue?vue&type=script&lang=js"
export * from "./eventolaborantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports